import { createIsIsEmptyBySearchSelector } from './create-is-empty-by-search/create-is-empty-by-search.selector';
import { createSearchFilteredDataIdsSelector } from './create-search-filtered-data-ids-selector/create-search-filtered-data-ids.selector';
import { createSearchOverlapsSelector } from './create-search-overlaps-selector/create-search-overlaps-selector.selector';
import { createSearchTextSelector } from './create-search-text-selector/create-search-text.selector';

export const SearchSelectors = {
  createIsIsEmptyBySearchSelector,
  createSearchOverlapsSelector,
  createSearchTextSelector,
  createSearchFilteredDataIdsSelector
};
